import { render, staticRenderFns } from "./dropdownMenu.vue?vue&type=template&id=513b54d2&scoped=true&"
import script from "./dropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./dropdownMenu.vue?vue&type=script&lang=ts&"
import style0 from "./dropdownMenu.vue?vue&type=style&index=0&id=513b54d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513b54d2",
  null
  
)

component.options.__file = "dropdownMenu.vue"
export default component.exports